import React from "react";
import { AccordionTitleView, DropDown, InputText } from "../../../components";
import { Grid } from "semantic-ui-react";
import { InputNumber } from "../../../components/InputText/InputNumber";
import { useForm } from "react-hook-form";

interface SupplierIngredientDetails {
  unitSize: number;
  unitType: string;
  eanBarcode: string;
  productId: string;
}

interface UnitType {
  key: string;
  value: string;
  text: string;
}

interface IngredientSupplierDetailsProps {
  originalSupplierIngredientData?: SupplierIngredientDetails | null;
  simulationSupplierIngredientData?: SupplierIngredientDetails | null;
  dataView?: boolean;
  unitTypes?: UnitType[];

}

const IngredientSupplierDetails: React.FC<IngredientSupplierDetailsProps> = ({
  originalSupplierIngredientData,
  simulationSupplierIngredientData,
  unitTypes

  
}) => {
  const UNIT_TYPES = [
    { key: "kg", value: "kg", text: "kg" },
    { key: "g", value: "g", text: "g" },
    { key: "l", value: "l", text: "l" },
    { key: "ml", value: "ml", text: "ml" }
  ];

  const defaultType = "ml";
  const dataView = false;
  const {
    register,
    formState: { errors },
    getValues,
    setValue,
    control
  } = useForm();
  return (
    <div>
      <AccordionTitleView accordionEnabled={false} title={""} plusIcon={false} />
      <Grid>
        <Grid.Row divided>
          <Grid.Column computer={8} tablet={16} mobile={16}>
            <Grid columns={4}>
              <Grid.Row>
                <Grid.Column>
                  <p className="textLabel mb-0">Unit Size</p>
                  <p className="textLabel">{originalSupplierIngredientData?.unitSize || 0}</p>
                </Grid.Column>
                <Grid.Column>
                  <p className="textLabel mb-0">Unit Type</p>
                  <p className="textLabel">{originalSupplierIngredientData?.unitType || ""}</p>
                </Grid.Column>
                <Grid.Column>
                  <p className="textLabel mb-0">EAN Barcode</p>
                  <p className="textLabel">{originalSupplierIngredientData?.eanBarcode || ""}</p>
                </Grid.Column>
                <Grid.Column>
                  <p className="textLabel mb-0">Product ID</p>
                  <p className="textLabel">{originalSupplierIngredientData?.productId || ""}</p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
          <Grid.Column computer={8} tablet={16} mobile={16}>
            <Grid columns={4}>
            <Grid.Row columns={8}>
              <Grid.Column computer={4} tablet={4} mobile={4}>
                <InputNumber
                  control={control}
                  errors={errors?.unit_size}
                  labelName={"Unit Size"}
                  placeholder="Unit Size"
                  name="unit_size"
                  required={true}
                  errorMessage={"Please enter unit size"}
                  type="number"
                  defaultValue={simulationSupplierIngredientData?.unitSize || 0}
                />
              </Grid.Column>

              <Grid.Column computer={4} tablet={4} mobile={4}>
                <DropDown labelName={"Unit Type"} currentData={UNIT_TYPES} defaultValue={simulationSupplierIngredientData?.unitType || "ml"} />
              </Grid.Column>

              <Grid.Column computer={4} tablet={4} mobile={4}>
                <InputText
                  register={register}
                  errors={errors?.ean_bar_code}
                  labelName={"EAN Barcode"}
                  placeholder="EAN Barcode"
                  name="ean_bar_code"
                  required={false}
                  defaultValue={simulationSupplierIngredientData?.eanBarcode || ""}
                />
              </Grid.Column>

              <Grid.Column computer={4} tablet={4} mobile={4}>
                <InputText
                  register={register}
                  errors={errors?.product_id}
                  labelName={"Product ID"}
                  placeholder="Product ID"
                  name="product_id"
                  required={false}
                  defaultValue={simulationSupplierIngredientData?.productId || ""}
                />
              </Grid.Column>
            </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
};

export default IngredientSupplierDetails;
